export * from './templates-filter.component';
export * from './templates-filter.component.module';